import React from 'react';
import { useNavigate } from 'react-router-dom';

const QUICK_QUESTIONS = [
  { label: '🔥 What needs attention today?', q: 'What needs my attention today?' },
  { label: '💰 7-day action plan', q: 'Give me a 7-day business action plan.' },
  { label: '📈 Explain Autonomy Score', q: 'Explain my Autonomy Score and how to improve it.' },
];

export default function AskNewaSummaryCard() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: '#ffffff',
        borderRadius: '16px',
        padding: '20px 26px',
        border: '1px solid rgba(39, 28, 82, 0.09)',
        boxShadow: '0 6px 24px rgba(15, 10, 40, 0.04)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '20px',
        width: '100%',
        marginBottom: '18px',
        boxSizing: 'border-box',
      }}
    >
      {/* Left Section: Status Badge + Title + Bullets */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap', flex: 1, minWidth: '280px' }}>
        {/* Green Checkmark Badge */}
        <div
          style={{
            width: '44px',
            height: '44px',
            borderRadius: '50%',
            backgroundColor: '#10B981',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 6px 16px rgba(16, 185, 129, 0.3)',
            flexShrink: 0,
          }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        {/* Title & Status Info */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <div style={{ fontSize: '19px', fontWeight: '700', color: '#111827', letterSpacing: '-0.02em' }}>
            Business is Healthy
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13.5px', color: '#4B5563', fontWeight: '500' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', border: '2px solid #10B981', backgroundColor: '#ECFDF5', flexShrink: 0 }} />
              Everything looks good!
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13.5px', color: '#4B5563', fontWeight: '500' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', border: '2px solid #F59E0B', backgroundColor: '#FEF3C7', flexShrink: 0 }} />
              2 Items need your attention.
            </div>
          </div>
        </div>
      </div>

      {/* Middle Section: Quick Question Chips */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        {QUICK_QUESTIONS.map((chip, idx) => (
          <button
            key={idx}
            onClick={() => navigate(`/asknewa?q=${encodeURIComponent(chip.q)}`)}
            style={{
              background: '#F5F3FF',
              border: '1px solid rgba(124, 58, 237, 0.15)',
              borderRadius: '999px',
              padding: '6px 14px',
              fontSize: '12px',
              fontWeight: '600',
              color: '#5B21B6',
              cursor: 'pointer',
              transition: 'all 0.18s ease',
              fontFamily: 'inherit',
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#7C3AED';
              e.currentTarget.style.color = '#ffffff';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#F5F3FF';
              e.currentTarget.style.color = '#5B21B6';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            {chip.label}
          </button>
        ))}
      </div>

      {/* Right Section: Ask NEWA Primary Button */}
      <button
        onClick={() => navigate('/asknewa')}
        style={{
          background: 'linear-gradient(135deg, #6366F1 0%, #7C3AED 50%, #4C1D95 100%)',
          color: '#ffffff',
          border: 'none',
          borderRadius: '12px',
          padding: '13px 26px',
          fontSize: '14.5px',
          fontWeight: '700',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          cursor: 'pointer',
          boxShadow: '0 6px 20px rgba(124, 58, 237, 0.35)',
          transition: 'all 0.2s ease',
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(124, 58, 237, 0.45)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(124, 58, 237, 0.35)';
        }}
      >
        <span style={{ fontSize: '16px' }}>✦</span>
        <span>Ask NEWA</span>
        <span style={{ fontSize: '14px', opacity: 0.9 }}>➔</span>
      </button>
    </div>
  );
}
